import AbsenceDetailsProvider from './AbsenceDetailsContext';
import AbsenceDetails from './AbsenceDetails';

let Index = () => {
    return (
        <AbsenceDetailsProvider>
            <AbsenceDetails />
        </AbsenceDetailsProvider>
    )
}

export default Index;